import React, { Component } from "react";
import { Accordion, Table, Image } from "semantic-ui-react";
import _ from "lodash";

class BusinessCreditRatings extends Component {
  constructor(props) {
    super(props);
    this.loadData(props);
  }

  state = {
    activeIndex: 0,
    rows: [],
  };

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  getScore = (creditScore) => {
    switch (creditScore) {
      case "A":
        return 100;
      case "B":
        return 75;
      case "C":
        return 50;
      case "D":
        return 25;
      default:
        return 0;
    }
  };

  getChartUrl = (score) =>
    `http://chart.apis.google.com/chart?chco=000000&chd=t:${score}&chdl=A%2B%20=%2095-100/Excellent|A%20=%2090-94/Excellent|B%2B%20=%2085-89/Very%20Good|B%20=%2080-84/Very%20Good|C%2B%20=%2070-79/Good|C%20=%2060-69/Good|I%20=%20Institution/Government|U%20=%20Unknown&chdlp=r&chds=50,100&chl=${score}&chma=1,30,1,30&chs=350x180&cht=gm&chts=FF0000,30,r&chxl=0:|U|I|C|C%2B|B|B%2B|A|A%2B&chxt=y`;

  loadData = (props) => {
    const rows = [];
    if (props.node !== undefined) {
      const score = this.getScore(_.get(props.node, "creditScore[0]._", ""));
      rows.push(
        <Table.Row key={"Row_credit_ratings"}>
          <Table.Cell>
            <Image src={this.getChartUrl(score)} />
          </Table.Cell>
        </Table.Row>
      );
    }
    this.state = { rows, activeIndex: 0 };
  };

  render() {
    return (
      <Accordion fluid styled key={`Business_Section_Credit_Rating`}>
        <Accordion.Title
          className="report-section-header"
          active={this.state.activeIndex === 0}
          key={`Business_Credit_Rating_Title`}
          onClick={() => this.handleClick()}
        >
          <p>
            Business Credit Rating
            <span className={"icon-toggle-accordion"}>
              {this.state.activeIndex === 0 ? "-" : "+"}
            </span>
          </p>
        </Accordion.Title>
        <Accordion.Content
          key={`Business_Credit_Rating_Body`}
          active={this.state.activeIndex === 0}
        >
          <Table>
            <Table.Body>{this.state.rows}</Table.Body>
          </Table>
        </Accordion.Content>
      </Accordion>
    );
  }
}

export default BusinessCreditRatings;



// WEBPACK FOOTER //
// ./src/components/reports/Business/BusinessCreditRatings.js